import React, { useEffect,useState } from 'react';
import Footer from '@/components/Footer';
import Logo from '@/assets/logo.svg';
import LoginForm from './form';
import RegisterForm from './registerForm';
import ResetForm from './resetForm';
import LoginBanner from './banner';
import styles from './style/index.module.less';
import axiosInstance from '@/utils/axiosInstance';
function Login(props) {
	const [systemType,setsystemType] = useState(localStorage.getItem("systemType"));
	const queryParams = new URLSearchParams(props.location.search)
	const termToken = queryParams.get("token")
	const termUsername = queryParams.get("username")
	const [webLogo,setwebLogo] = useState('');
	
	const [isShowLogin,setisShowLogin] = useState(true);
	const [isShowRegist,setisShowRegist] = useState(false);
	const [isShowrest,setisShowrest] = useState(false);
	// useEffect(() => {
	// 	document.body.setAttribute('arco-theme', 'light');
	// }, []);
 //  function config() {
 //    axiosInstance.get('/system/config')
 //      .then((res) => {

 //        if (res.data.code === 0) {
	// 		setwebLogo(res.data.data.web_logo);
		
 //        }
 //    })
 //  }
 
	const [aliCaptchaPrefix,setaliCaptchaPrefix] = useState('')
	const [aliCaptchaSceneIdWeb,setaliCaptchaSceneIdWeb] = useState('')
	 
	useEffect(() => {
		setTimeout(()=>{
			systemConfig()
		},1000)
	}, []);
	 
	function systemConfig(){
		axiosInstance.get('/system/config?isToken=false')
		  .then((res) => {
			if (res.data.code === 0) {
				setaliCaptchaPrefix(res.data.data.ali_captcha_prefix);
				setaliCaptchaSceneIdWeb(res.data.data.ali_captcha_sceneId_web);

			}
		})
	}
 
  useEffect(()=>{
  	 if(systemType=='1'){
		 setwebLogo('https://haitzhitou.oss-cn-shanghai.aliyuncs.com/feed/90818a657dac4f84afaf0d6b0d145b5.png');
	 }
	 if(systemType=='2'){
		 setwebLogo('https://haitzhitou.oss-cn-shanghai.aliyuncs.com/storage/uploads/20231226/55f63ad880c5d9b65227f19a44ed16b2.png');
	 }
  },[systemType])
  return (
    <div className={styles.container}>
      <div className={styles.logo}>
		{webLogo!='' &&(
			<img src={webLogo} style={{marginTop:-20,width:134,height:60}} />
		)}
		
		
        <div className={styles['logo-text']}></div>
      </div>
      <div className={styles.banner}>
        <div className={styles['banner-inner']}>
          <LoginBanner />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles['content-inner']}>
		{isShowLogin &&(
			<LoginForm termToken={termToken} termUsername={termUsername} setisShowLogin={setisShowLogin} setisShowRegist={setisShowRegist} setisShowrest={setisShowrest} aliCaptchaPrefix={aliCaptchaPrefix} aliCaptchaSceneIdWeb={aliCaptchaSceneIdWeb}/>
		)}
		{isShowRegist &&(
			<RegisterForm setisShowLogin={setisShowLogin} setisShowRegist={setisShowRegist} aliCaptchaPrefix={aliCaptchaPrefix} aliCaptchaSceneIdWeb={aliCaptchaSceneIdWeb}/>
		)}
		{isShowrest &&(
			<ResetForm setisShowLogin={setisShowLogin} setisShowrest={setisShowrest} aliCaptchaPrefix={aliCaptchaPrefix} aliCaptchaSceneIdWeb={aliCaptchaSceneIdWeb}/>
		)}
        </div>
        <div className={styles.footer}>
          <Footer />
        </div>
      </div>
    </div>
  );
}
Login.displayName = 'LoginPage';

export default Login;
